<app-page-content [showProgress]="progress" [showBackButton]="true">
  <span pagetitle>Sending {{shipment.Number}}</span>

  <div pagecontent class="container">
    <div style="display: flex; flex-direction: column; flex: 0 0 30%; max-width: 30%">
      <app-expand-panel title="Sendingsinformasjon">
        <div class="shipment_details_box">
          <app-field title="Status">
            <span>{{shipment | shipmentStatusName}}{{shipment.HasDeviations ? ' (avvik)' : ''}}</span>
          </app-field>
          <app-field title="Bærer" *ngIf="carrierName !== null"><span>{{carrierName}}</span></app-field>
          <app-field title="Antall kolli"><span>{{shipment.Parcels.length}}</span></app-field>
          <app-field title="Leveringsinstruks" *ngIf="shipment.DeliveryInstruction !== null">
            <span>{{shipment.DeliveryInstruction}}</span>
          </app-field>
          <app-field title="Senders ref." *ngIf="shipment.SenderReference !== null">
            <span>{{shipment.SenderReference}}</span>
          </app-field>
          <app-field title="Ekstern sporing" *ngIf="shipment.ExternalTrackingUrl !== null">
            <a href="{{shipment.ExternalTrackingUrl}}">{{shipment.ExternalTrackingUrl}}</a>
          </app-field>
          <app-field title="Totalvekt" *ngIf="shipment.TotalWeightInKg !== null">
            <span>{{shipment.TotalWeightInKg|number:'1.1-1'}} kg</span>
          </app-field>
          <app-field title="Registrert"><span>{{shipment.CreatedAt | date:'dd.MM.yy HH:mm'}}</span>
          </app-field>
          <app-field title="Oppdatert" *ngIf="shipment.OrderUpdatedAt !== null">
            <span>{{shipment.OrderUpdatedAt | date:'dd.MM.yy HH:mm'}}</span>
          </app-field>
          <app-field class="attachments" title="Vedlegg" *ngIf="shipment.AttachmentIds != null && shipment.AttachmentIds.length > 0">
            <a (click)="showAttachments(shipment.AttachmentIds)">{{shipment.AttachmentIds.length}} bilde{{shipment.AttachmentIds.length > 1 ? 'r' : ''}}</a>
          </app-field>
        </div>
      </app-expand-panel>
      <app-expand-panel title="Avsender">
        <div class="address_box">
          <span>{{shipment.Sender.Name}}</span>
          <span>{{shipment.Sender.Address}}</span>
          <span>{{shipment.Sender.PostCode}} {{shipment.Sender.City}}</span>
        </div>
      </app-expand-panel>
      <app-expand-panel title="Mottaker">
        <div class="address_box">
          <span>{{shipment.Receiver.Name}}</span>
          <span>{{shipment.Receiver.Address}}</span>
          <span>{{shipment.Receiver.PostCode}} {{shipment.Receiver.City}}</span>
        </div>
      </app-expand-panel>
    </div>
    <app-expand-panel title="Hendelser" style="flex: 1 1 auto">
      <div *ngIf="events.length == 0" class="empty_message">Ingen hendelser</div>
      <div *ngIf="events.length > 0" class="event_entry_container">
        <div class="event_entry" *ngFor="let event of events">
          <div class="event_entry_line">
            <span>{{event.number}}</span><span
            *ngIf="event.parcelDescription !== null">, {{event.parcelDescription}}</span>
            <span style="flex: 1 1 auto;"></span>
            <span>{{event.createdAt | date:'dd.MM.yy HH:mm'}}</span>
          </div>
          <div style="display: flex; flex-direction: row; margin-bottom: 0.5em">
            <span>{{event.name}}</span><span *ngIf="event.description !== null">, {{event.description}}</span>
            <span style="flex: 1 1 auto;"></span>
            <span>{{event.username}}</span>
            <a class="attachments" *ngIf="event.attachmentIds != null && event.attachmentIds.length > 0" (click)="showAttachments(event.attachmentIds)">{{event.attachmentIds.length}} bilde{{event.attachmentIds.length > 1 ? 'r' : ''}}</a>
          </div>
          <div *ngIf="event.signature !== null" class="signature_box">
            <img class="signature_image" [src]="domSanitizer.bypassSecurityTrustResourceUrl('data:image/PNG;base64,' + event.signature.Base64PngData)">
            <div class="signature_name_box">
              {{event.signature.Name}}
            </div>
          </div>
        </div>
      </div>
    </app-expand-panel>
  </div>

  <app-button-box pagefooter>
    <button mat-raised-button color="primary" *ngIf="session.shipmentLabelPrintingIsEnabled()" (click)="printLabel()">SKRIV UT ETIKETTER</button>
    <button mat-raised-button color="primary" *ngIf="shipment.OrderStatus === 'Unassigned'" (click)="assign()">TILDEL
    </button>
    <button mat-raised-button color="primary" *ngIf="shipment.OrderStatus === 'Offer'" (click)="queryUnassign()">FJERN
      TILDELING
    </button>
    <button mat-raised-button color="warn" (click)="queryDelete()">SLETT SENDING</button>
  </app-button-box>
</app-page-content>
